import React from "react";
import { useEffect, useMemo, useRef, useState } from "react";
import { Close } from "@mui/icons-material";
import { Dialog, Slide, IconButton, Paper } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useAppSelector } from "@/hooks";
import { ContentStatus, Offer } from "@/types";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OffersPopups = () => {
  const [isOpen, setIsOpen] = useState(false);
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const currentOrganization = useAppSelector((store) => store.organizations[organizationId] ?? null);
  const wasRendered = useRef(false);

  const offert = useMemo(() => {
    if (!currentOrganization?.content?.length) return [];

    const content = currentOrganization?.content.filter((content: Offer) => {
      if (!("region" in content)) return false;

      if (content.status === ContentStatus.PUBLISHED && content.component === "popup") {
        return content;
      }
    });

    return content[0];
  }, [currentOrganization?.content]);

  useEffect(() => {
    if (offert && !wasRendered.current) {
      wasRendered.current = true;
      setIsOpen(true);
    }
  }, [offert]);

  if (!offert) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} TransitionComponent={Transition} PaperProps={{ sx: { borderRadius: 6 } }}>
      <IconButton
        size="large"
        elevation={2}
        component={Paper}
        onClick={() => setIsOpen(false)}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
        }}
      >
        <Close />
      </IconButton>
      <img key={offert.id} width="100%" src={offert?.images[0]} alt={offert?.title} />
    </Dialog>
  );
};

export default OffersPopups;
